
import React, { useState } from 'react';
import { Course } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Courses/PathItems';
import { OperationRequest } from '@peercolab/engine';
import { CourseManagment } from '../../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Session } from '../../peer-colab-model/Session';
import { useToast } from '../../providers/ToastProvider';
import { useCourses } from '../../providers/CourseProvider';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';




interface CourseModulesTabProps {
  course: Course;
  patchField: <R, V>(operation: OperationRequest<unknown, R>, newValue: V, currentValue: V, revertHandler: (value: V) => void) => Promise<void>;
  onEditModule: (moduleId: string) => void;
}

function CourseModulesTab({ course, patchField, onEditModule }: CourseModulesTabProps) {
  const { onError } = useToast()
  const { loadCourse } = useCourses()
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newModuleName, setNewModuleName] = useState('');
  const [newModuleDescription, setNewModuleDescription] = useState('');
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [moduleToDelete, setModuleToDelete] = useState<string | null>(null);
    // const [editingModuleId, setEditingModuleId] = useState<string | null>(null);

  const handleDeleteClick = (moduleId: string) => {
    setModuleToDelete(moduleId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
    setModuleToDelete(null);
  };


  const handleDeleteDialogOk = async () => {
    if (moduleToDelete) {
      await patchField(
        CourseManagment.removeModule({ moduleId: moduleToDelete }),
        moduleToDelete,
        moduleToDelete,
        () => {}
      );
    }
    handleDeleteDialogClose();
  };


  const handleDialogOpen = () => {
    setNewModuleName('');
    setNewModuleDescription('');
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setNewModuleName('');
  };


  const handleDialogOk = async () => {
    if (newModuleName.trim()) {
      onError((await Session.getCourseClient(course.id).request(CourseManagment.addModule({ name: newModuleName.trim(), description: newModuleDescription })))
        .maybeOk(() => loadCourse(course.id)));
    }
    handleDialogClose();
  };

  // Move module logic can be implemented with a patchField if backend supports reordering

  // Handler to go back to modules list from editing


  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" gutterBottom>Modules</Typography>
        <Button variant="contained" onClick={handleDialogOpen}>New Module</Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Lesson count</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {course.modules.map((mod, idx) => (
              <TableRow key={mod.module.name}>
                <TableCell>{mod.module.name}</TableCell>
                <TableCell>{mod.module.description}</TableCell>
                <TableCell>{mod.module.lessons.length}</TableCell>
                <TableCell align="right">
                  {/* Move module actions can be implemented if backend supports reordering */}
                  <IconButton size="small" color="primary" onClick={() => onEditModule(mod.module.id)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton size="small" color="error" onClick={() => handleDeleteClick(mod.module.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Add Module</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Module Name"
            fullWidth
            autoFocus
            value={newModuleName}
            onChange={e => setNewModuleName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Module Description"
            fullWidth
            value={newModuleDescription}
            onChange={e => setNewModuleDescription(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleDialogOk} variant="contained">OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteDialogOpen} onClose={handleDeleteDialogClose}>
        <DialogTitle>Delete Module</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this module?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>Cancel</Button>
          <Button onClick={handleDeleteDialogOk} variant="contained" color="error">OK</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default CourseModulesTab;
